exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-header{padding:0 20px;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib!./~/element-ui/lib/theme-chalk/header.css
// module id = 190
// module chunks = 0